const apiURL = process.env.REACT_APP_API_URL;

export const getCursos = async( category ) => {

    const pathArray = window.location.pathname.split('/');
    const peten = "peten";
    
    const delegacionCentral = 1;
    const delegacionPeten = 2;
    
    const delegacion = pathArray.includes(peten) ? (delegacionPeten) : (delegacionCentral);
    
    // const url = `http://localhost:5000/api/Courses/GetList?code=${delegacion}&search=${ encodeURI( category ) }`;
    const url = apiURL+ `/Courses/GetList?code=${delegacion}&search=${ encodeURI( category ) }`;

    const resp = await fetch ( url );
    const data = await resp.json();
    
    const curso = data.map( curso => {
        
        return {

            id : curso?.catCursosId,
            imagen : curso?.imageUrl,
            nombre : curso?.nombreCurso,
            modalidad : curso?.modalidad,
            codigo : curso?.codigoCurso,
            edicion : curso?.numeroEdicion,
            catedratico : curso?.catedratico,
            estudiantes : curso?.cupoActual,
            fechaInicio : curso?.fechaDeInicioInscripcion

        }
    })

    return curso;

}